{
  "main": {
    "title": "Massa e baricentro",
    "nazaj": "Indietro"
  },
  "labelswb": {
    "isci": "Cerca / seleziona il velivolo",
    "izberi": "seleziona",
    "odstrani": "rimuovi",
    "izbrano": "selezionato",
    "neObstaja": "il velivolo cercato non è tra i velivoli",
    "praznaLista": "nessun velivolo da visualizzare"
  },
  "tekstwb": {
    "opozorilo": "Il velivolo {plovilo} non ha impostato i parametri per W&B!",
    "opozorilo_podrobno": " Comunicate all'amministratore la registrazione del velivolo, affinché aggiunga i parametri necessari."
  },
  "grafwb": {
    "opozorilo": "Il velivolo {plovilo} non ha i parametri wgt1-5 impostati per visualizzare il grafico W&B!",
    "opozorilo_podrobno": " Comunicare al gestore la registrazione dell'aeromobile affinché aggiunga i parametri necessari."
  },
  "obrazec": {
    "labels": {
      "tezaLetalo": "Peso (a vuoto) dell'aeromobile",
      "izpisTeze": "Peso ",
      "izpisMomenta": "Momento",
      "pilot": "Pilota e sedile anteriore",
      "sopotniki": "Passeggeri",
      "gorivo": "Carburante",
      "ptrljaga": "Bagagli",
      "sTeza": "Peso totale",
      "sMoment": "Momento totale",
      "sMasa": "Massa totale",
      "maksimalno": "Massimo:",
      "kalkulacija": "Calcolo"
    }
  }
}